declare namespace $ {

	type $mol_select__value_shm_dashboard_admin_auth_1 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_auth['dashboard_url'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_dashboard_admin_auth_2 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_auth['dashboard_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_auth_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_auth_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__hint_shm_dashboard_admin_auth_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_dashboard_admin_auth_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_auth['email'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_auth_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_auth_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_password__value_shm_dashboard_admin_auth_9 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_auth['password'] >
		,
		ReturnType< $mol_password['value'] >
	>
	type $mol_password__submit_shm_dashboard_admin_auth_10 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_auth['submit'] >
		,
		ReturnType< $mol_password['submit'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_auth_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_auth_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_shm_dashboard_admin_auth_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_dashboard_admin_auth_14 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_auth['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_shm_dashboard_admin_auth_15 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_auth['submit_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_text__text_shm_dashboard_admin_auth_16 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_auth['message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_dashboard_admin_auth_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_auth_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_auth_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_auth_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_auth_21 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_auth['logout'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_auth_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_auth_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_dashboard_admin_auth extends $mol_page {
		content_rows( ): readonly(any)[]
		dashboard_url( next?: string ): string
		dashboard_options( ): Record<string, any>
		Dashboard( ): $mol_select
		Dashboard_label( ): $mol_labeler
		email( next?: string ): string
		Email( ): $mol_string
		Email_label( ): $mol_labeler
		password( next?: string ): string
		submit( next?: any ): any
		Password( ): $mol_password
		Password_label( ): $mol_labeler
		submit_enabled( ): boolean
		Submit( ): $mol_button_major
		message( next?: string ): string
		Message( ): $mol_text
		superuser_label( ): string
		Current_user( ): $mol_view
		Current_label( ): $mol_labeler
		logout( next?: any ): any
		Logout( ): $mol_button_minor
		title( ): string
		token( next?: string ): string
		user_id( next?: string ): string
		state( id: any, next?: string ): string
		pb_url_override( next?: string ): string
		body( ): ReturnType< $shm_dashboard_admin_auth['content_rows'] >
		Login_form( ): $mol_view
		Session( ): $mol_view
	}
	
}

//# sourceMappingURL=auth.view.tree.d.ts.map